/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
export const FlyoutContext = React.createContext(undefined);
export const useFlyoutContext = () => {
    const context = React.useContext(FlyoutContext);
    if (context === undefined) {
        throw new Error('Flyout Context is undefined');
    }
    return context;
};
export const Provider = FlyoutContext.Provider;
